export default {
    userSignup: {
        userId: null,
        email: null,
        phoneNumber: null,
    },
};
